import * as MyMath from 'helpers/MyMath';
import { HOME_SCREEN } from 'routes';
import { routeSelector } from 'ducks/routeSelectors';

import { SET_HUE } from 'ducks/actionTypes';




const defaultState = {
	hue: 216
};


function uiReducer(state=defaultState, action) {
	switch (action.type) {
		case SET_HUE:
			return {
				...state,
				hue: action.payload.hue
			};

		default:
			return state;
	}
}

export default uiReducer;





///////////////////////////////////
//                               //
//            ACTIONS            //
//                               //
///////////////////////////////////

// Set the hue.
export const setHue = hue => ({ type: SET_HUE, payload: { hue } });

// Change the hue, including side effects to update theme color everywhere.
// If `nextHue` is not provided, will auto select a new hue that's at least somewhat different from the current.
export const changeThemeHue = (nextHue) => {
	return function changeHueThunk(dispatch, getState) {
		const state = getState();

		// Only allow hue to be changed on home screen.
		if (routeSelector(state) !== HOME_SCREEN) {
			return;
		}

		if (typeof nextHue !== 'number') {
			const hue = hueSelector(state);
			const minDiff = 32;
			do {
				nextHue = getRandomHue();
			}
			while (Math.abs(nextHue - hue) < minDiff);
		}

		// Update the app with a new hue. Of course dispatches an action, but also performs two side effects:
		//  - Update CSS `--hue-primary` variables
		//  - Update the application "theme-color" set via meta tag (this indeed triggers an update in Chrome!)

		dispatch(setHue(nextHue));
		document.documentElement.style.setProperty('--hue-primary', String(nextHue));
		// Our UI animations the transition, but the Android status bar does not appear to.
		// So, We'll change the "theme-color" half way through so the change feels less jarring.
		// Maybe we want to animate this manually at some point?
		setTimeout(() => {
			const metaThemeColorNode = document.querySelector('meta[name=theme-color]');
			metaThemeColorNode.setAttribute('content', `hsl(${nextHue}, 98%, 28%)`);
		}, 250);
	};
};




/**
 * Hue helper function returns a random hue within a specific range.
 *
 * @return {int}
 */
function getRandomHue() {
	return Math.random() < 0.1
		? MyMath.randomInt(0, 12)
		: MyMath.randomInt(148, 260);
}





///////////////////////////////////
//                               //
//           SELECTORS           //
//                               //
///////////////////////////////////

export const hueSelector = state => state.ui.hue;



// WEBPACK FOOTER //
// ./src/ducks/ui.js